import { createContext } from "react";

const riderContext = createContext();

export default riderContext;
